/**
 * 仅供 LLM 消费的内部技术标记：落库与展示前必须剥离，用户不应看到。
 * 前后端共享同一组正则（前端展示剥离；服务端落库剥离）。
 */
const INTERNAL_MARKER_PATTERNS: RegExp[] = [
  /\s*\[NO_EARN_FX\]\s*/g,
];

export function stripInternalMarkers(text: string): string {
  return INTERNAL_MARKER_PATTERNS.reduce(
    (acc, re) => acc.replace(re, ''),
    text,
  ).trim();
}